.content-wrapper {
    display: flex;
    flex-direction: column;
    gap: 32px;
}
